import { useEffect, useState } from "react";
import { MiniDialer } from "./mini-dialer";

// Wave 2 — Browser dialer foundations: global host that listens for a
// `entertaincrm:dialer:open` CustomEvent. Any spreadsheet/cell can
// dispatch this event to surface the mini-dialer overlay without taking
// a direct dependency on the dialer module.
//
// Example trigger:
//   window.dispatchEvent(new CustomEvent("entertaincrm:dialer:open", {
//     detail: { phone: "+15551234567", contactName: "Acme", leadId: "..." }
//   }));

interface DialerOpenDetail {
  phone: string;
  contactName?: string | null;
  leadId?: string | null;
  clientId?: string | null;
}

export function DialerHost() {
  const [open, setOpen] = useState<DialerOpenDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<DialerOpenDetail>).detail;
      if (detail?.phone) setOpen(detail);
    };
    window.addEventListener("entertaincrm:dialer:open", handler as EventListener);
    return () => window.removeEventListener("entertaincrm:dialer:open", handler as EventListener);
  }, []);

  if (!open) return null;
  return (
    <MiniDialer
      phone={open.phone}
      contactName={open.contactName || null}
      leadId={open.leadId || null}
      clientId={open.clientId || null}
      onClose={() => setOpen(null)}
    />
  );
}
